import clsx from 'clsx'
import React from 'react'

import { ConditionList } from '@/screens/Cart/page/ui/condition-list/condition-list'
import { SpecialCondition } from '@/screens/Product/page/types/types'

import { ProductGiftForBasketItem } from '@/features/cart/gift'

import { TCartItem, useCart } from '@/entities/cart'

import { BASE_URL, PRODUCT_URL } from '@/shared/lib/const/env'
import { useGetRelatedProducts } from '@/shared/lib/hooks/useGetRelatedProducts'
import { TSection } from '@/shared/types/deprecated-types'
import { OrderType } from '@/shared/types/product-types'

import { BasketItemTable } from '../basket-item-table/basket-item-table'

import { AppliedAccessoriesSection } from './applied-accessories-section'
import { ServicesSection } from './services-section'

import cl from './basket-item.module.scss'

export type BasketItemProps = TCartItem & {
	count?: number
	additional?: boolean
	isJuridicalUser?: boolean
	categories?: TSection[]
	conditionList?: SpecialCondition[]
}

export const BasketItem = (props: BasketItemProps): JSX.Element => {
	const {
		KOD,
		IMAGE,
		TITLE,
		PRICE,
		ACCESSORIES,
		QUANTITY,
		BONUS,
		SERVICES,
		ID_BASKET,
		ORDER_TYPE,
		SECTION_ID,
		ID,
		conditionList,
		isJuridicalUser
	} = props

	const relatedProducts = useGetRelatedProducts(ID)
	const { changeCount, deleteItem, isLoading } = useCart()

	const itemLink = PRODUCT_URL + KOD
	const imageSrc = IMAGE ? BASE_URL + IMAGE : `/product-image-placeholder.jpeg`

	return (
		<li className={cl.basketItem} aria-label="Товар">
			<BasketItemTable
				productCode={KOD}
				ariaLabel="Информация о товаре"
				title={TITLE}
				link={itemLink}
				imageSrc={imageSrc}
				price={PRICE}
				initialCount={QUANTITY}
				bonus={BONUS}
				idBasket={ID_BASKET}
				relatedId={ID}
				productId={ID}
				onQuantityChange={changeCount}
				orderType={ORDER_TYPE}
				onDeleteButtonClick={deleteItem}
				footer={
					<>
						{!!conditionList?.length && !isJuridicalUser ? (
							<ConditionList items={conditionList} productId={ID} relatedProducts={relatedProducts} />
						) : null}
						{ORDER_TYPE !== OrderType.HideBuy && (
							<div
								className={clsx(cl.relatedProducts, isLoading && cl.relatedProducts_disabled)}
								aria-label="Дополнительные услуги и товары">
								<ServicesSection
									productId={ID}
									services={!isJuridicalUser ? SERVICES : []}
									isJuridicalUser={isJuridicalUser}
								/>

								<AppliedAccessoriesSection productId={ID} sectionId={SECTION_ID} accessories={ACCESSORIES} />
							</div>
						)}
					</>
				}
			/>

			<ProductGiftForBasketItem productId={ID} />
		</li>
	)
}
